export const ROUTES = {
  HOME: '/',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  CONFIRM_SIGN_UP: '/confirmsignup',
  FORGOT_PASSWORD: '/forgotpassword',
  CONFIRM_FORGOT_PASSWORD: '/confirmforgotpassword',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  CREATE_RECIPE: '/recipes/new',
  RECIPE_DETAIL: '/recipes/:id',
  EDIT_RECIPE: '/recipes/:id/edit',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
